export const X_FIELD = 'x';
export const Y_FIELD = 'y';
export const COLOR_FIELD = 'name';
export const NODES_VIEW_ID = 'nodes';
export const EDGES_VIEW_ID = 'views';
